import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({
  width = '0',
  progressBarClass = ''
}) => (
  <div className="progress-container flex middle">
    <div className="progress">
      <div
        className={`progress-bar-inner ${progressBarClass}`}
        role="progressbar"
        style={{ width: `${width}%` }}
        aria-valuenow={width}
        aria-valuemin="0"
        aria-valuemax="100"
      />
    </div>
    <div className="text-green percent-text">{width}%</div>
  </div>
);

ProgressBar.propTypes = {
  width: PropTypes.string,
  progressBarClass: PropTypes.string
};

export default ProgressBar;
